enum PageView {
  LIST,
  CREATE,
  EDIT,
}

export { PageView };
